<template>
    <div>

        <div class="inter-nav__status-line"></div>
        <div
            v-for="(item, i) in items"
            :key="i"
            class="inter-nav__container d-flex align-items-center mb-2"
        >
            <div class="inter-nav__status d-flex flex-column mr-3">
                <div class="inter-nav__status-icon">
                    <span v-if="item.visited">
                        <img
                            v-svg-inline
                            src="@/assets/ui/visited-green.svg"
                            width="100%"
                            height="100%"
                        />
                    </span>
                    <span v-if="item.active">
                        <img
                            v-svg-inline
                            :class="`inter-nav__icon-active--${item.variant}`"
                            src="@/assets/ui/active-blue.svg"
                            width="100%"
                            height="100%"
                        />
                    </span>
                    <span v-if="!item.visited && !item.active">

                    <img
                        v-svg-inline
                        v-if="!item.visited && !item.active"
                        src="@/assets/ui/locked-silver.svg"
                        width="100%"
                        height="100%"
                    />
                    </span>
                </div>
            </div>
            <div class="w-100">
                <part-button
                    class="inter-nav__part-button"
                    @click="handleClick(item)"
                    :variant="item.variant"
                    :active="item.active"
                    :isLoading="isLoading"
                    :navigationInProgress="navigationInProgress"
                >
                    <span v-html="item.content" />
                </part-button>
            </div>
        </div>

    </div>
</template>
<script>
import partButton from '@/components/ui/partButton'

export default {
    name: 'intermediateNavigation',
    components: {
        'part-button': partButton,
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        isLoading: {
          type: Boolean,
          default: false
        },
         navigationInProgress: {
          type: Boolean,
          default: false
        }
    },
    methods: {
        handleClick(item) {
            this.$emit('click', item)
        }
    }
}
</script>
<style lang="scss">
    .inter-nav__status-line {
        height: 85%;
        position: absolute;
        top: 20px;
        left: 34px;
        border-right: 2px solid $base_grey-2;
        z-index: 0;
    }

    .inter-nav__status-icon {
        z-index: 10;
        background-color: white;
        width: 40px;
        height: 60px;
        padding: 15px 5px;
    }

    .inter-nav__part-button {
        height: 80px;
    }

    .inter-nav__icon-active--bq-burgundy {
        > g {
            stroke: $bq-burgundy;
            > g {
                stroke: $bq-burgundy;
            }
            > g:last-child {
                fill: $bq-burgundy;
            }
        }
    }

    .inter-nav__icon-active--bq-green {
        > g {
            stroke: $bq-green;
            > g {
                stroke: $bq-green;
            }
            > g:last-child {
                fill: $bq-green;
            }
        }
    }

    .inter-nav__icon-active--bq-blue {
        > g {
            stroke: $bq-blue;
            > g {
                stroke: $bq-blue;
            }
            > g:last-child {
                fill: $bq-blue;
            }
        }
    }

    .inter-nav__icon-active--bq-turquoise {
        > g {
            stroke: $bq-turquoise;
            > g {
                stroke: $bq-turquoise;
            }
            > g:last-child {
                fill: $bq-turquoise;
            }
        }
    }

    .inter-nav__icon-active--bq-red {
        > g {
            stroke: $bq-red;
            > g {
                stroke: $bq-red;
            }
            > g:last-child {
                fill: $bq-red;
            }
        }
    }

    .inter-nav__icon-active--bq-orange {
        > g {
            stroke: $bq-orange;
            > g {
                stroke: $bq-orange;
            }
            > g:last-child {
                fill: $bq-orange;
            }
        }
    }
</style>
